import Enllac from 'components/corporatiu/Enllac';
import Imatge from 'components/corporatiu/Imatge';
import __isEmpty from 'lodash/isEmpty';
import { useViewport } from 'hooks/corporatiu/useViewport';
import styles from './destacatEnllac.module.scss';

const DestacatEnllac = (props) => {
    const { item, src } = props;
    const { id, titol, slug, descripcio } = item || props;
    const route = {
        type: 'web_transparencia_seccio',
        slug,
        id
    };
    const { isOnlyMobile } = useViewport();

    return (
        <Enllac route={route} dataTestId='destacat-enllac'>
            <div className={styles.destacatEnllac}>
                <div className={styles.imatgeWrapper}>
                    <Imatge className={styles.imatge} src={src} alt={titol} aria-hidden='true' height='60' width='60' />
                </div>
                <h2 className={styles.titol}>{titol}</h2>
                {!isOnlyMobile && <p className={styles.descripcio}>{descripcio}</p>}
                {!isOnlyMobile && (
                    <div className={styles.accedeixWrapper}>
                        <span className={styles.accedeix}>Accedeix</span>
                    </div>
                )}
            </div>
        </Enllac>
    );
};

export default DestacatEnllac;
